export const initCookiePolicy = () => {
  const cookieCloseSelector = $(".js-cookie-close");
  const readMoreSelector = $(".js-read-more");
  const readLessSelector = $(".js-read-less");
  const cookiePolicy = $(".cookie-policy");
  const EXPANDED = "expanded";
  const IS_VISIBLE = "is-visible";

  if (
    cookieCloseSelector.length ||
    readMoreSelector.length ||
    readLessSelector.length ||
    cookiePolicy.length
  ) {
    setTimeout(() => {
      cookiePolicy.addClass(IS_VISIBLE);
    }, 4000);

    cookieCloseSelector.each(function() {
      $(this).on("click", function() {
        cookiePolicy.removeClass(IS_VISIBLE);
      });
    });

    readMoreSelector.each(function() {
      $(this).on("click", function(e) {
        e.preventDefault();
        cookiePolicy.addClass(EXPANDED);
      });
    });

    readLessSelector.each(function() {
      $(this).on("click", function(e) {
        e.preventDefault();
        cookiePolicy.removeClass(EXPANDED);
      });
    });
  }
};
